import { reactive } from 'vue'

const theme = reactive({
  agentLogo: '',
  devLogo: 'logo.png',
  apiUrl: 'https://api.metaluxe.com.au/',
  bunnyApiUrl: 'https://api.bunny.net/',

  videoLibraryId: '598869',
  streamCdnUrl: 'vz-cc31a6f9-ad0.b-cdn.net',
  streamApiKey: '9ff00db4-c42e-4488-88fb6b8b548a-283b-4c40',

  storageApiPassword: '6d5df3cc-332e-4780-9e48a6166450-4ce8-4cb0',
  cdnUrl: 'https://margaret-ave-pwa.b-cdn.net',
  devFolder: '/margaret-ave-pwa',

  cinematicsIcon: '/img/ui-theme/videos-icon.svg',
  rendersIcon: '/img/ui-theme/renders-icon.svg',
  rangeIcon: '/img/ui-theme/range-icon.svg',
  panoramasIcon: '/img/ui-theme/panoramas-icon.svg',
  '360-ToursIcon': '/img/ui-theme/panoramas-icon.svg',

  dashboardMp4: '/theme/dashboard/background-video.mp4',

  // top level menu
  assetsMenuOrder: ['Cinematics', '360-Tours'],

  orderAssetsMenu: ['3 Bed', 'Amenities', 'Exterior'],

  retreatAsset: {
    panoramas: [0],
    panoramasName: ['Margaret Ave'],
    panoramasUrl: ['https://storage.net-fs.com/hosting/7566552/51/'],
    balconyViews: [0],
    balconyViewsName: ['Margaret Ave'],
    balconyViewsUrl: [''],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
  },
  rootTopAsset: {
    balconyViews: [0],
    balconyViewsName: ['Margaret Ave'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/173/'],
  },
  level19Asset: {
    balconyViews: [0],
    balconyViewsName: ['Margaret Ave'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/174/'],
  },
})

export default { theme }
